import * as Chartist from 'chartist';
import Component from '../common/component';
import Constants from '../common/constants';
import Statistics from '../common/statisticsData';
export default class StatisticsPage extends Component {
    constructor(parentElement) {
        super(parentElement, 'div', 'statistics-wrapper');
        this.spinnerWrapper = new Component(this.node, 'div', 'spinner-wrapper');
        this.spinner = new Component(this.spinnerWrapper.node, 'div', 'lds-dual-ring');
        this.content = new Component(this.node, 'div', 'statistics-content');
        this.learnedWordsWrapper = new Component(this.content.node);
        this.learnedWordsAllTime = new Component(this.learnedWordsWrapper.node, 'p', 'statistic-group-title');
        this.todayStatistic = new Component(this.content.node, 'p', 'statistic-group-title');
        this.gamesWrapper = new Component(this.content.node, 'div', 'statistics-games-wrapper');
        this.sprintStreaks = new Component(this.gamesWrapper.node, 'p', 'statistics-sprint-streaks');
        this.audioStreaks = new Component(this.gamesWrapper.node, 'p', 'statistics-audio-streaks');
        this.wordsWrapper = new Component(this.content.node, 'div', 'statistics-words-wrapper');
        this.seenWords = new Component(this.wordsWrapper.node, 'p');
        this.learnedWords = new Component(this.wordsWrapper.node, 'p');
        this.allTimeChartsTitle = new Component(this.node, 'p', 'statistic-group-title');
        this.allTimeChartsTitle.node.style.marginTop = '20px';
        this.seenChartTitle = new Component(this.node, 'p');
        this.seenChart = new Component(this.node, 'div', 'ct-line');
        this.learnedChartTitle = new Component(this.node, 'p');
        this.learnedChart = new Component(this.node, 'div', 'ct-line');
        if (!Constants.UserMetadata) {
            this.spinnerWrapper.destroy();
            this.node.style.marginTop = '30vh';
            this.learnedWordsAllTime.node.textContent =
                'Статистика доступна только для зарегистрированных пользователей';
            return;
        }
        const statistics = Statistics.get();
        statistics.then(async (data) => {
            if (data) {
                setTimeout(() => {
                    var _a, _b, _c, _d;
                    this.seenChartTitle.node.textContent = 'Новые слова:';
                    this.learnedChartTitle.node.textContent = 'Изученные слова:';
                    this.learnedWordsAllTime.node.textContent = data.optional.learnedWordsList
                        ? `Слов изучено: ${data.optional.learnedWordsList.length}`
                        : 'Слов изучено: 0';
                    this.todayStatistic.node.textContent = 'Статистика за сегодня:';
                    const sprintStreak = (_a = data.optional.sprintStreakPerDay[data.optional.sprintStreakPerDay.findIndex((el) => el.date === Statistics.currentDay)]) === null || _a === void 0 ? void 0 : _a.streak;
                    this.sprintStreaks.node.textContent = sprintStreak
                        ? `Спринт: самая длинная серия: ${sprintStreak}`
                        : 'Спринт: самая длинная серия: 0';
                    const audioStreak = (_b = data.optional.audioStreakPerDay[data.optional.audioStreakPerDay.findIndex((el) => el.date === Statistics.currentDay)]) === null || _b === void 0 ? void 0 : _b.streak;
                    this.audioStreaks.node.textContent = audioStreak
                        ? `Аудиовызов: самая длинная серия: ${audioStreak}`
                        : 'Аудиовызов: самая длинная серия: 0';
                    const newWords = (_c = data.optional.newWordsPerDay[data.optional.newWordsPerDay.findIndex((el) => el.date === Statistics.currentDay)]) === null || _c === void 0 ? void 0 : _c.words;
                    this.seenWords.node.textContent = newWords
                        ? `Новые слова: ${newWords}`
                        : 'Новые слова: 0';
                    const learnedWords = (_d = data.optional.learnedWordsPerDay[data.optional.learnedWordsPerDay.findIndex((el) => el.date === Statistics.currentDay)]) === null || _d === void 0 ? void 0 : _d.words;
                    this.learnedWords.node.textContent = learnedWords
                        ? `Изученные слова: ${learnedWords}`
                        : 'Изученные слова: 0';
                    const months = [
                        'января',
                        'февраля',
                        'марта',
                        'апреля',
                        'мая',
                        'июня',
                        'июля',
                        'августа',
                        'сентября',
                        'октября',
                        'ноября',
                        'декабря',
                    ];
                    this.allTimeChartsTitle.node.textContent = 'Статистика за все время:';
                    let seenWordsCount = 0;
                    const seenLabels = [];
                    let seenChartData = data.optional.newWordsPerDay.map((el, i) => {
                        seenWordsCount += el.words;
                        seenLabels.push(`${new Date(el.date).getDate()} ${months[new Date(el.date).getMonth()]}`);
                        return {
                            x: i,
                            y: seenWordsCount,
                        };
                    });
                    if (seenChartData.length > 30)
                        seenChartData = seenChartData.slice(-29);
                    if (seenChartData.length < 30) {
                        const a = { x: -1, y: 0 };
                        seenChartData.unshift(a);
                        seenLabels.unshift('До обучения');
                    }
                    new Chartist.LineChart(this.seenChart.node, {
                        labels: seenLabels,
                        series: [seenChartData],
                    }, {
                        height: '20vh',
                        chartPadding: {
                            right: 20,
                        },
                        axisX: {
                            showGrid: true,
                            onlyInteger: true,
                            showLabel: true,
                        },
                        axisY: {
                            showGrid: true,
                            onlyInteger: true,
                        },
                    });
                    const learnedLabels = [];
                    let learnedWordsCount = 0;
                    let learnedChartData = data.optional.learnedWordsPerDay.map((el, i) => {
                        learnedWordsCount += el.words;
                        learnedLabels.push(`${new Date(el.date).getDate()} ${months[new Date(el.date).getMonth()]}`);
                        return {
                            x: i,
                            y: learnedWordsCount,
                        };
                    });
                    if (learnedChartData.length > 30)
                        learnedChartData = learnedChartData.slice(-29);
                    if (learnedChartData.length < 30) {
                        const a = { x: -1, y: 0 };
                        learnedChartData.unshift(a);
                        learnedLabels.unshift('До обучения');
                    }
                    new Chartist.LineChart(this.learnedChart.node, {
                        labels: learnedLabels,
                        series: [learnedChartData],
                    }, {
                        height: '20vh',
                        chartPadding: {
                            right: 20,
                        },
                        axisX: {
                            showGrid: true,
                            onlyInteger: true,
                            showLabel: true,
                        },
                        axisY: {
                            showGrid: true,
                            onlyInteger: true,
                        },
                    });
                    this.spinnerWrapper.destroy();
                }, 300);
            }
        });
    }
}
